"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.mergeUrlQueryParams = mergeUrlQueryParams;
exports.parseQueryParams = parseQueryParams;
exports.queryRegex = void 0;

var _querystring = require("querystring");

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var queryRegex = /\?([^#]*)/;
exports.queryRegex = queryRegex;

function mergeUrlQueryParams(urlString, params) {
  if (urlString === void 0) {
    urlString = '';
  }

  if (!urlString) {
    return "?" + (0, _querystring.stringify)(params);
  }

  var queryMatch = urlString.match(queryRegex);
  var query = {};

  if (queryMatch) {
    query = (0, _querystring.parse)(queryMatch[1]);
  }

  query = (0, _pickBy["default"])((0, _merge["default"])(query, params), function (p) {
    return !(0, _isUndefined["default"])(p);
  });
  var newQuery = (0, _querystring.stringify)(query);

  if (queryMatch) {
    return urlString.replace(queryRegex, "?" + newQuery);
  }

  return urlString + "?" + newQuery;
}

function parseQueryParams(queryStr) {
  if (queryStr === void 0) {
    queryStr = '';
  }

  var paramStr = queryStr.substring(queryStr.indexOf('?') + 1);
  return (0, _querystring.parse)(paramStr);
}